import React from 'react';
import PropTypes from 'prop-types';
import { gql, useQuery } from '@apollo/client';
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessage, SelectDropdown } from '@gsa/afp-component-library';

export const GET_CURRENT_AND_FUTURE_CONTRACT_LINE_COUNT_BY_SI_ID = gql`
  query getCurrentAndFutureContractLineCountBySIId($standardItemId: Float!) {
    contractLineCount: getCurrentAndFutureContractLineCountBySIId(
      standardItemId: $standardItemId
    )
  }
`;

export const STATUSES = [
  {
    value: '',
    label: 'Select',
  },
  {
    value: 1,
    label: 'Active',
  },
  {
    value: 0,
    label: 'Inactive',
  },
];

const StatusInput = ({ disabled = false, standardItemId }) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const { data: { contractLineCount } = {} } = useQuery(
    GET_CURRENT_AND_FUTURE_CONTRACT_LINE_COUNT_BY_SI_ID,
    {
      fetchPolicy: 'cache-and-network',
      variables: { standardItemId: +standardItemId },
      skip: disabled || !standardItemId,
    },
  );
  const renderRequiredComponent = (value) => {
    return (
      <>
        {/* eslint-disable-next-line */}
        <h2 className="font-sans-xs" tabIndex="0" aria-label={value}>
          {value} <span className="usa-hint usa-hint--required">*</span>
        </h2>
      </>
    );
  };

  return (
    <>
      {renderRequiredComponent('Status')}
      <Controller
        name="isActive"
        control={control}
        defaultValue=""
        rules={{ required: 'This field is required' }}
        render={({ field }) => (
          <SelectDropdown
            aria-label="status"
            id="si_form_status_sel"
            onBlur={field.onBlur}
            onChange={field.onChange}
            value={field.value}
            options={STATUSES}
            disabled={disabled || (standardItemId && contractLineCount !== 0)}
          />
        )}
      />
      {errors?.status?.message && (
        <ErrorMessage>{errors.status.message}</ErrorMessage>
      )}
    </>
  );
};

StatusInput.propTypes = {
  disabled: PropTypes.bool,
  standardItemId: PropTypes.string,
};

export default StatusInput;
